<template>
  <div class="controller-review">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item class="mb-5" label="Tiêu đề" prop="title">
          <a-input v-model="form.title" placeholder="Tiêu đề" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Nội dung" prop="content">
          <a-textarea :rows="4" v-model="form.content" placeholder="Nội dung" />
        </a-form-model-item>
        <a-form-model-item>
          <a-row type="flex" justify="end">
            <a-button
              type="primary"
              :loading="callingAPI"
              @click="handleSubmit"
            >
              {{ $route.params.id ? "Cập nhật" : "Thêm mới" }}
            </a-button>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import { createProcess, updateProcess, fetchProcessById } from '@/services/landing-page/career/recruitment-process'
  export default {
    name: 'ControllerRecruitmentProcess',
    data() {
      return {
        callingAPI: false,

        form: {
          title: '',
          content: '',
          active: '1'
        },
        rules: {
          name: [
            { required: true, message: 'Giá trị không được để trống.', trigger: ['blur', 'change'] },
          ],
          content: [
            { required: true, message: 'Giá trị không được để trống.', trigger: ['blur', 'change'] },
          ],
        },

        avatarUrl: "",
      }
    },
    async beforeMount() {
      if (this.$route.params.id) {
        await this.loadData()
      }
    },
    methods: {
      async loadData() {
        try {
          const response = await fetchProcessById(this.$route.params.id)
          this.form = {
            ...response.data,
          }
        } catch (error) { }
      },
      handleSubmit(e) {
        e.preventDefault();
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            try {
              this.callingAPI = true

              const data = {
                title: this.form.title,
                description: this.form.description,
                content: this.form.content,
                active: this.form.active,
                post_type: 2,
                type: 3,
              }

              if (this.$route.params.id) {
                data._method = 'PUT'
              }

              let response = null;
              if (this.$route.params.id) {
                 response = await updateProcess(this.$route.params.id, data)
              } else {
                 response = await createProcess(data)
              }
              if (response.status == 1) {
                const message = this.$route.params.id
                  ? "Cập nhật thành công."
                  : "Thêm mới thành công.";
                this.$notification.success({
                  message: "Thành công",
                  description: message,
                });
                this.$router.push({ name: "ManageRecruitmentProcess" });
              } else {
                this.$notification.error({
                  message: "Thất bại",
                  description: response.errors[0],
                });
              }
            } catch (error) {
              this.callingAPI = false
              console.log(error);
            }
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>